import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoshirdicabs() {



  const cardData =
  {
    keyword: ' Pune to Shirdi Cab',
    heading: 'Sai Trupti Cabs: Pune to Shirdi Cab',
    headingDescription: 'Sai Trupti Cabs provides reliable and comfortable Pune to Shirdi cab services, offering a safe and peaceful journey for devotees visiting the holy town of Sai Baba. Our fleet of air-conditioned Sedans, SUVs, and Luxury cars ensures a pleasant travel experience with clean interiors, spacious seating, and smooth performance. Whether you’re planning a family pilgrimage or a solo trip to Shirdi Sai Baba Temple, our professional and background-verified chauffeurs guarantee punctual pickups, courteous service, and safe driving throughout the journey. With transparent pricing, flexible one-way and round-trip options, and 24×7 customer support, Sai Trupti Cabs makes your spiritual travel convenient and worry-free. Experience a serene and comfortable ride from Pune to Shirdi with Sai Trupti Cabs — your trusted partner for devotional and outstation cab services.',

    top: 'Top Places to Visit in Shirdi with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Sai Baba Samadhi Mandir",
    "description": "The Sai Baba Samadhi Mandir is the sacred heart of Shirdi and the most revered pilgrimage site in Maharashtra. Built in marble, it houses the resting place of Shri Sai Baba, radiating peace and divine energy. Devotees from across the world visit daily to offer prayers and witness the mesmerizing aarti ceremonies. The temple’s white marble statue of Sai Baba exudes serenity and compassion, reminding visitors of his eternal teachings of love, unity, and selfless service."
  },
  {
    "title": "Dwarkamai Mosque",
    "description": "Dwarkamai Mosque holds immense spiritual importance as Sai Baba lived here for over 60 years. This humble structure symbolizes faith, patience, and divine grace, where Baba healed the sick and helped the needy. The sacred dhuni (eternal flame) still burns here, representing purity and spiritual continuity. Devotees visit Dwarkamai to experience Baba’s living presence and witness the divine simplicity that continues to guide millions of hearts toward goodness and truth."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is another significant shrine in Shirdi, where Sai Baba spent every alternate night during the last years of his life. The place still preserves his wooden bed, palkhi, and photographs that recreate the divine aura of his presence. The traditional palkhi procession from Dwarkamai to Chavadi is a highlight for devotees, reflecting the deep bond between the saint and his followers. It stands as a timeless reminder of discipline, devotion, and divine grace."
  },
  {
    "title": "Gurusthan",
    "description": "Gurusthan marks the exact spot where Sai Baba was first seen as a young boy meditating under a neem tree. Today, a small shrine with a marble statue of Baba and a sacred Shivling draws thousands of visitors seeking spiritual awakening. The neem tree’s roots are believed to have miraculous healing powers. Gurusthan beautifully connects Shirdi’s divine past with the living devotion of its present, inspiring faith and humility among pilgrims."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a serene garden where Sai Baba spent time daily, watering plants and meditating under trees. The garden still houses the lamp lit by Baba, which continues to burn eternally in his memory. Shaded paths, tranquil surroundings, and the fragrance of flowers make it a peaceful retreat for devotees. Lendi Baug reflects Baba’s deep love for nature and simplicity, reminding visitors that spirituality thrives in acts of care and compassion."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple holds historical importance as the place where Sai Baba first arrived in Shirdi and was affectionately addressed as 'Ya Sai' by the temple priest. Dedicated to Lord Khandoba, the temple signifies the moment when Baba’s divine journey in Shirdi began. Pilgrims visit this modest shrine to pay homage to both Lord Khandoba and Sai Baba’s first blessing in the town. It’s a sacred site connecting faith, history, and divine destiny."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is an open-air museum that artistically depicts the life and miracles of Sai Baba through realistic sculptures and dioramas. The peaceful environment, traditional architecture, and storytelling displays offer a beautiful blend of devotion and learning. Visitors, especially families, find it a perfect place to understand Baba’s message in a visual and interactive way. The village also features play areas and food stalls, making it a wholesome spiritual retreat."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Wet N Joy Water Park offers a refreshing contrast to Shirdi’s spiritual ambiance, providing family-friendly entertainment and relaxation. Spread across 10 acres, it features thrilling slides, a wave pool, and dedicated zones for kids. After a divine darshan, visitors often unwind here to enjoy fun-filled moments with family. Its cleanliness, safety measures, and proximity to the temple make it one of Shirdi’s most popular leisure destinations."
  },
  {
    "title": "Dixit Wada Museum",
    "description": "Located within the Sai Baba Temple complex, Dixit Wada Museum showcases a collection of Sai Baba’s personal belongings — robes, utensils, footwear, and rare photographs. The museum preserves Baba’s legacy and offers a glimpse into his simple, ascetic lifestyle. Visitors feel a deep connection as they view artifacts that once touched the saint’s life. It’s a must-visit for devotees seeking to understand Sai Baba’s humility and timeless wisdom."
  },
  {
    "title": "Shani Shingnapur Temple",
    "description": "Located about 70 km from Shirdi, Shani Shingnapur Temple is dedicated to Lord Shani and is famous for its unique open-air shrine where no door or lock exists in the entire village. The belief that Lord Shani protects every devotee instills immense faith among visitors. Pilgrims often combine their Shirdi darshan with a visit here, completing a spiritually enriching journey. The temple’s aura of trust and divine justice continues to attract devotees from all over India."
  }
],



"services": [
  {
    "name": "Pune to Shirdi Cab",
    "description": "Pune to Shirdi Cab provides a comfortable and convenient travel option for pilgrims and travelers visiting Shirdi from Pune. Services include air-conditioned vehicles, professional drivers, online booking, transparent fares, 24/7 support, and real-time ride tracking for a hassle-free journey."
  },
  {
    "name": "Pune to Shirdi Taxi",
    "description": "Pune to Shirdi Taxi offers reliable taxi services for one-way or round trips to Shirdi, featuring experienced chauffeurs, spacious AC vehicles, online booking, fare transparency, and 24/7 assistance for a smooth and safe trip."
  },
  {
    "name": "Pune to Shirdi Car Hire",
    "description": "Pune to Shirdi Car Hire provides flexible rental options for chauffeur-driven or self-drive trips to Shirdi. Features include comfortable AC vehicles, reliable drivers, online booking, transparent fares, and round-the-clock customer support."
  },
  {
    "name": "Pune to Shirdi Innova Cab",
    "description": "Pune to Shirdi Innova Cab offers premium travel in a spacious Innova vehicle with professional chauffeurs, air-conditioning, online booking, fare transparency, real-time ride tracking, and 24/7 customer assistance."
  },
  {
    "name": "Pune to Shirdi Ertiga Cab",
    "description": "Pune to Shirdi Ertiga Cab provides a comfortable and spacious travel experience with AC interiors, professional drivers, online booking, fare transparency, real-time tracking, and 24/7 support, ideal for families or small groups."
  },
  {
    "name": "Pune to Shirdi Sedan Cab",
    "description": "Pune to Shirdi Sedan Cab offers a smooth and comfortable ride in air-conditioned sedans, complete with professional chauffeurs, online booking, transparent fares, and 24/7 customer support for both one-way and round trips."
  },
  {
    "name": "Pune to Shirdi One Way Taxi",
    "description": "Pune to Shirdi One Way Taxi ensures hassle-free one-way travel from Pune to Shirdi with AC vehicles, professional drivers, online booking, transparent fares, real-time ride tracking, and 24/7 support."
  },
  {
    "name": "Pune to Shirdi Drop Cab",
    "description": "Pune to Shirdi Drop Cab provides reliable door-to-door drop service with comfortable vehicles, experienced drivers, online booking, fare transparency, and 24/7 customer assistance for a safe journey."
  },
  {
    "name": "Pune to Shirdi Airport Taxi",
    "description": "Pune to Shirdi Airport Taxi offers convenient airport drop and pickup services with air-conditioned cars, professional chauffeurs, online booking, transparent fares, real-time tracking, and 24/7 support."
  },
  {
    "name": "Pune to Shirdi Outstation Cab",
    "description": "Pune to Shirdi Outstation Cab ensures comfortable long-distance travel with spacious AC vehicles, professional drivers, online booking, transparent fares, real-time tracking, and 24/7 assistance for a stress-free journey."
  },
  {
    "name": "Affordable Pune to Shirdi Taxi",
    "description": "Affordable Pune to Shirdi Taxi provides budget-friendly travel options without compromising comfort. Services include AC vehicles, professional drivers, online booking, transparent fares, and 24/7 support."
  },
  {
    "name": "Pune to Shirdi Luxury Cab",
    "description": "Pune to Shirdi Luxury Cab offers premium travel with high-end vehicles, experienced chauffeurs, air-conditioning, online booking, fare transparency, real-time ride tracking, and 24/7 customer support."
  },
  {
    "name": "Pune to Shirdi Online Booking",
    "description": "Pune to Shirdi Online Booking allows seamless cab reservations with instant confirmation, multiple vehicle options, transparent fares, real-time ride tracking, and 24/7 assistance for a hassle-free experience."
  },
  {
    "name": "Pune to Shirdi AC Cab",
    "description": "Pune to Shirdi AC Cab provides a comfortable air-conditioned ride for travelers from Pune to Shirdi with professional chauffeurs, online booking, fare transparency, real-time tracking, and 24/7 support."
  },
  {
    "name": "Pune to Shirdi Travel Service",
    "description": "Pune to Shirdi Travel Service offers comprehensive travel solutions including one-way trips, round trips, and outstation journeys with air-conditioned vehicles, professional drivers, online booking, transparent fares, and 24/7 assistance."
  }
],
"tableData": [
  ["Pune to Shirdi Cab", "Pune to Shirdi Taxi"],
  ["Pune to Shirdi Car Hire", "Pune to Shirdi Innova Cab"],
  ["Pune to Shirdi Ertiga Cab", "Pune to Shirdi Sedan Cab"],
  ["Pune to Shirdi One Way Taxi", "Pune to Shirdi Drop Cab"],
  ["Pune to Shirdi Airport Taxi", "Pune to Shirdi Outstation Cab"],
  ["Affordable Pune to Shirdi Taxi", "Pune to Shirdi Luxury Cab"],
  ["Pune to Shirdi Online Booking", "Pune to Shirdi AC Cab"],
  ["Pune to Shirdi Travel Service", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Shirdi Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs Pvt Ltd offers reliable and comfortable cab services from Pune to Shirdi — ideal for pilgrimage, family travel or leisure road trips."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "We offer clear one‑way fare estimates from Pune to Shirdi, starting at approx. ₹2,100–₹2,500 for sedans. :contentReference[oaicite:1]{index=1}"
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs or premium cars to suit your group size, luggage and comfort preferences for the Pune to Shirdi route. :contentReference[oaicite:2]{index=2}"
  },
  {
    "WhyChooseheading": "Experienced & Punctual Drivers",
    "WhyChoosedescription": "Our courteous, professional drivers are familiar with the Pune‑to‑Shirdi route, ensuring a safe, smooth and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide convenient pickups from anywhere in Pune (city, airport, suburbs) and drop‑offs in Shirdi (town, railway station, temple vicinity)."
  },
  {
    "WhyChooseheading": "Clean, Well‑Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized and maintained to ensure comfort and reliability for the longer drive from Pune to Shirdi."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, route planning or any travel changes."
  },
  {
    "WhyChooseheading": "Hassle‑Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Shirdi cab easily via call, WhatsApp or our website — with instant confirmation and prompt vehicle dispatch."
  }
]




































  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Shirdi cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pune to Shirdi cab services for one way, round trip, and group travel.',
  },
  {
    question: 'How can I book a Pune to Shirdi cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Shirdi cab through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available from Pune to Shirdi?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and luxury cabs to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for Pune to Shirdi trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in long-distance travel, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I hire a cab from Pune to Shirdi for family or group trips?',
    answer: 'Certainly. Our cab services cater to family trips, group tours, and religious travel from Pune to Shirdi.',
  },
  {
    question: 'Is the Pune to Shirdi cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services for Pune to Shirdi trips for your convenience and flexible travel plans.',
  },
  {
    question: 'What are the Pune to Shirdi cab fares?',
    answer: 'Our cab fares start from ₹2,000 for sedans, ₹2,500–₹3,500 for SUVs and Innova Crysta, depending on vehicle type, group size, and travel requirements.',
  },
  {
    question: 'What payment options are accepted for Pune to Shirdi cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune to Shirdi cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures to ensure a secure journey.',
  },
  {
    question: 'Is customer support available during the Pune to Shirdi cab ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Pune to Shirdi cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Joshi',
    feedback: 'I booked a Pune to Shirdi cab with Sai Trupti Cabs. The ride was comfortable, and the driver was very professional and punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Patil',
    feedback: 'Sai Trupti Cabs provided excellent service for our Pune to Shirdi trip. Smooth journey and very courteous driver.',
    rating: 5,
  },
];






























































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shirdi Cab",
  "image": "https://saitrupticabs.com/assets/images/pune-to-shirdi-cab.jpg",
  "description": "Book Pune to Shirdi Cab with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15864"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-shirdi-cab"
  }
};




  return (
    <div>
      <Helmet>
  <title>Pune to Shirdi Cab | Safe & Comfortable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Shirdi Cab with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking." 
  />
  <meta 
    name="keywords" 
    content="Pune to Shirdi Cab, Pune to Shirdi Taxi, Pune to Shirdi Car Hire, Pune to Shirdi Innova Cab, Pune to Shirdi Ertiga Cab, Pune to Shirdi Sedan Cab, Pune to Shirdi One Way Taxi, Pune to Shirdi Drop Cab, Pune to Shirdi Airport Taxi, Pune to Shirdi Outstation Cab, Affordable Pune to Shirdi Taxi, Pune to Shirdi Luxury Cab, Pune to Shirdi Online Booking, Pune to Shirdi AC Cab, Pune to Shirdi Travel Service" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/newimages/7.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoshirdicabs;